module.exports = __webpack_public_path__ + "5708b78e3a12618ccf6eeeb721e77f42.svg";